import React from "react";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class SnackbarAlert extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            open:true,

        }
    }
    handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({open: false})
    };
    render() {
        return(
            <div>
                <Snackbar open={this.state.open} autoHideDuration={6000} onClose={this.handleCloseSnack}>
                    <Alert onClose={this.handleCloseSnack} severity={this.props.severity}>
                        {this.props.message}
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}
export default SnackbarAlert;